module.exports = __webpack_public_path__ + "static/logo-a1ead10da5d89ddaa29bf9110b654aff.svg";